import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-translate";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const Paginator = ({ totalPages, currentPage, filter, callback, t }) => {
  const maxPagesToShow = 20; // Máximo de páginas a mostrar
  const halfRange = Math.floor(maxPagesToShow / 2);
  let startPage = Math.max(0, currentPage - halfRange);
  let endPage = Math.min(totalPages - 1, startPage + maxPagesToShow - 1);

  // Ajustar el rango si está cerca del final
  if (endPage - startPage + 1 < maxPagesToShow) {
    startPage = Math.max(0, endPage - maxPagesToShow + 1);
  }

  const handleClick = (e, index) => {
    callback(index, filter); // Enviar página actual
  };

  return (
    <nav aria-label="paginator lists">
      <Pagination>
        {/* Botón Primera Página */}
        <PaginationItem disabled={currentPage <= 0}>
          <PaginationLink onClick={(e) => handleClick(e, 0)}>
            {t("first")}
          </PaginationLink>
        </PaginationItem>

        {/* Botón Anterior */}
        <PaginationItem disabled={currentPage <= 0}>
          <PaginationLink onClick={(e) => handleClick(e, currentPage - 1)}>
            {t("previous-practice")}
          </PaginationLink>
        </PaginationItem>

        {/* Páginas en el rango */}
        {[...Array(totalPages)]
          .map((_, i) => i)
          .slice(startPage, endPage + 1)
          .map((page) => (
            <PaginationItem active={page === currentPage} key={page}>
              <PaginationLink onClick={(e) => handleClick(e, page)} href="#">
                {page + 1}
              </PaginationLink>
            </PaginationItem>
          ))}

        {/* Botón Siguiente */}
        <PaginationItem disabled={currentPage >= totalPages - 1}>
          <PaginationLink onClick={(e) => handleClick(e, currentPage + 1)}>
            {t("next-practice")}
          </PaginationLink>
        </PaginationItem>

        {/* Botón Última Página */}
        <PaginationItem disabled={currentPage >= totalPages - 1}>
          <PaginationLink onClick={(e) => handleClick(e, totalPages - 1)}>
            {t("last")}
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    </nav>
  );
};

Paginator.defaultProps = {
  totalPages: 1,
  currentPage: 0,
  pageSize: 1,
  filter: null,
};

Paginator.propTypes = {
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
  filter: PropTypes.string,
  callback: PropTypes.func,
};

export default translate("paginator-search")(Paginator);